module.exports = __webpack_public_path__ + "img/92168.a13d17dc.svg";